/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var productColourChosen;
var variant;
var meta;

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function AutoRoundel() {
  var statusMode = false;
  if (variant.compare_at_price) {
    if (variant.compare_at_price > variant.price) {
      var discountAmt = variant.compare_at_price - variant.price;
      discountAmt /= 100;
      //alert(discountAmt);
      var roundelImg =
        "https://cdn.shopify.com/s/files/1/0270/3474/6980/files/promo_blank_200x.png?v=1603368914";
      var roundelText = "Discounted!";
      statusMode = true;
      var el = document.querySelector(
        ".roundelProduct img:not(#shopify-section-product-recommendations .roundelProduct img)"
      );
      el.setAttribute("src", roundelImg);
      //$('.roundelProduct img').not("#shopify-section-product-recommendations .roundelProduct img").attr('src',roundelImg);
      el = document.querySelector(
        ".TextRollBack:not(#shopify-section-product-recommendations .TextRollBack)"
      );
      try {
        el.innerHTML = roundelText;
      } catch (e) {}
      //$('.TextRollBack').not("#shopify-section-product-recommendations .TextRollBack").text(roundelText);

      el = document.querySelector(
        ".roundelProduct .DiscountOverlay:not(#shopify-section-product-recommendations .roundelProduct .DiscountOverlay)"
      );
      if (el == null) {
        var iDiv = document.createElement("div");
        iDiv.className = "DiscountOverlay";
        var targetEl = document.querySelector(
          ".roundelProduct:not(#shopify-section-product-recommendations .roundelProduct)"
        );
        targetEl.appendChild(iDiv);
      }
      //if($('.roundelProduct .DiscountOverlay').not("#shopify-section-product-recommendations .roundelProduct .DiscountOverlay").length<=0){
      // 	$('.roundelProduct').not("#shopify-section-product-recommendations .roundelProduct").append('<div class="DiscountOverlay"></div>');
      //}
      el = document.querySelector(
        ".roundelProduct .DiscountOverlay:not(#shopify-section-product-recommendations .roundelProduct .DiscountOverlay)"
      );
      el.innerHTML = "<span>Save<br/></span>&pound;" + discountAmt;
      //$('.roundelProduct .DiscountOverlay').not("#shopify-section-product-recommendations .roundelProduct .DiscountOverlay").html("<span>Save<br/></span>&pound;"+discountAmt);
      el = document.querySelector(
        ".roundelProduct .DiscountOverlay:not(#shopify-section-product-recommendations .DiscountOverlay)"
      );
      el.style.visibility = "visible";
      el = document.querySelector(
        ".roundelProduct:not(#shopify-section-product-recommendations .roundelProduct)"
      );
      el.style.visibility = "visible";
      //el = document.querySelectorAll(".roundelProduct .DiscountOverlay");
      //el[0].style.visibility = "visible";
      //$('.roundelProduct, .DiscountOverlay').not("#shopify-section-product-recommendations .roundelProduct, #shopify-section-product-recommendations .DiscountOverlay").css('visibility','visible');
    } else {
      var el = document.querySelector(
        ".roundelProduct .DiscountOverlay:not(#shopify-section-product-recommendations .DiscountOverlay)"
      );
      if (el !== null) {
        el.style.visibility = "hidden";
      }
      el = document.querySelector(
        ".roundelProduct:not(#shopify-section-product-recommendations .roundelProduct)"
      );
      el.style.visibility = "hidden";
      //$('.roundelProduct, .DiscountOverlay').not("#shopify-section-product-recommendations .roundelProduct, #shopify-section-product-recommendations .DiscountOverlay").css('visibility','hidden');
    }
  } else {
    var el = document.querySelector(
      ".roundelProduct .DiscountOverlay:not(#shopify-section-product-recommendations .DiscountOverlay)"
    );
    if (el !== null) {
      el.style.visibility = "hidden";
    }
    el = document.querySelector(
      ".roundelProduct:not(#shopify-section-product-recommendations .roundelProduct)"
    );
    el.style.visibility = "hidden";

    //$('.roundelProduct, .DiscountOverlay').not("#shopify-section-product-recommendations .roundelProduct, #shopify-section-product-recommendations .DiscountOverlay").css('visibility','hidden');
  }
  if (!statusMode) {
    var prodSku = variant.sku;
    var prodOpt3 = variant.option3;
    var roundelImg = "";
    var roundelText = "";
    if (prodSku.indexOf("swj-4-") > -1) {
      roundelImg =
        "https://cdn.shopify.com/s/files/1/0270/3474/6980/files/promo_comfy_200x.png?v=1603367820";
      roundelText = "Our most comfortable chesterfield";
    } else if (prodSku.indexOf("swj-2-") > -1) {
      roundelImg =
        "https://cdn.shopify.com/s/files/1/0270/3474/6980/files/promo_deep_200x.png?v=1603368235";
      roundelText = "Our deepest chesterfield";
    } else if (prodOpt3 == "With Sofabed" || prodOpt3 == "With Sofa Bed") {
      roundelImg =
        "https://cdn.shopify.com/s/files/1/0270/3474/6980/files/promo_base_sofabed_200x.png?v=1603363348";
      roundelText = "Available as a sofa bed";
    }
    if (roundelImg) {
      //$('.roundelProduct img').not("#shopify-section-product-recommendations .roundelProduct img").attr('src',roundelImg);
      var el = document.querySelector(
        ".roundelProduct img:not(#shopify-section-product-recommendations .roundelProduct img)"
      );
      el.setAttribute("src", roundelImg);
      if (roundelText) {
        //$('.TextRollBack').not("#shopify-section-product-recommendations .TextRollBack").text(roundelText);
        var el = document.querySelector(
          ".TextRollBack:not(#shopify-section-product-recommendations .TextRollBack)"
        );
        el.innerHTML = roundelText;
      }
      var el = document.querySelector(
        ".roundelProduct:not(#shopify-section-product-recommendations .roundelProduct)"
      );
      el.style.visiblity = "visible";
      //$('.roundelProduct').not("#shopify-section-product-recommendations .roundelProduct").css('visibility','visible');
    } else {
      var el = document.querySelector(
        ".roundelProduct .DiscountOverlay:not(#shopify-section-product-recommendations .DiscountOverlay)"
      );
      if (el !== null) {
        el.style.visibility = "hidden";
      }
      el = document.querySelector(
        ".roundelProduct:not(#shopify-section-product-recommendations .roundelProduct)"
      );
      el.style.visibility = "hidden";
      //$('.roundelProduct, .DiscountOverlay').not("#shopify-section-product-recommendations .roundelProduct, #shopify-section-product-recommendations .DiscountOverlay").css('visibility','hidden');
    }
  }
  return statusMode;
}

function sofaBedInf() {
  var s2ssbf = metaFields["2_seater_sb_frame"];
  var s2ssbm = metaFields["2_seater_sb_mattress"];

  var s3ssbf = metaFields["3_seater_sb_frame"];
  var s3ssbm = metaFields["3_seater_sb_mattress"];

  var s4ssbf = metaFields["4_seater_sb_frame"];
  var s4ssbm = metaFields["4_seater_sb_mattress"];

  var s5ssbf = metaFields["5_seater_sb_frame"];
  var s5ssbm = metaFields["5_seater_sb_mattress"];

  var s6ssbf = metaFields["6_seater_sb_frame"];
  var s6ssbm = metaFields["6_seater_sb_mattress"];

  if (s2ssbf === undefined) {
    s2ssbf = "";
  }
  if (s3ssbf === undefined) {
    s3ssbf = "";
  }
  if (s4ssbf === undefined) {
    s4ssbf = "";
  }

  if (s2ssbm === undefined) {
    s2ssbm = "";
  }
  if (s3ssbm === undefined) {
    s3ssbm = "";
  }
  if (s4ssbm === undefined) {
    s4ssbm = "";
  }

  if (s5ssbm === undefined) {
    s5ssbm = "";
  }
  if (s6ssbm === undefined) {
    s6ssbm = "";
  }

  var tempOpt1 = product.options[0];
  var tempOpt2 = product.options[1];
  var tempOpt3 = product.options[2];

  if (tempOpt1) {
    tempOpt1 = tempOpt1.toLowerCase();
  }
  if (tempOpt2) {
    tempOpt2 = tempOpt2.toLowerCase();
  }
  if (tempOpt3) {
    tempOpt3 = tempOpt3.toLowerCase();
  }

  var selectedSize = "";
  var selectedSofabed = "";

  if (tempOpt1 == "size") {
    selectedSize = document.querySelector(
      'input[name="option-0"]:checked'
    ).value;
  }
  if (tempOpt2 == "size") {
    selectedSize = document.querySelector(
      'input[name="option-1"]:checked'
    ).value;
  }
  if (tempOpt3 == "sofabed") {
    selectedSofabed = document.querySelector(
      'input[name="option-2"]:checked'
    ).value;
  }

  if (selectedSofabed == "With Sofa Bed") {
    if (
      ((s2ssbf != "" || s2ssbm != "") && selectedSize.indexOf("2") > -1) ||
      ((s3ssbf != "" || s3ssbm != "") && selectedSize.indexOf("3") > -1) ||
      ((s4ssbf != "" || s4ssbm != "") && selectedSize.indexOf("4") > -1) ||
      ((s5ssbf != "" || s5ssbm != "") && selectedSize.indexOf("5") > -1) ||
      ((s6ssbf != "" || s6ssbm != "") && selectedSize.indexOf("6") > -1)
    ) {
      var frameText = "";
      var mattressText = "";
      if (selectedSize.indexOf("2") > -1) {
        frameText = s2ssbf;
        mattressText = s2ssbm;
      } else if (selectedSize.indexOf("3") > -1) {
        frameText = s3ssbf;
        mattressText = s3ssbm;
      } else if (selectedSize.indexOf("4") > -1) {
        frameText = s4ssbf;
        mattressText = s4ssbm;
      } else if (selectedSize.indexOf("5") > -1) {
        frameText = s5ssbf;
        mattressText = s5ssbm;
      } else if (selectedSize.indexOf("6") > -1) {
        frameText = s6ssbf;
        mattressText = s6ssbm;
      }
      document.querySelector("#SofaBedFrameTitle").style.display = "block";
      document.querySelector("#SofaBedFrameInf").style.display = "block"; //.text(frameText).css('display','block');
      document.querySelector("#SofaBedFrameInf").innerHTML = frameText;
      document.querySelector("#SofaBedMattressTitle").style.display = "block";
      document.querySelector("#SofaBedMattressInf").style.display = "block"; //.text(mattressText).css('display','block');
      document.querySelector("#SofaBedMattressInf").innerHTML = mattressText;
    } else {
      document.querySelector("#SofaBedFrameTitle").style.display = "none"; //('display','none');
      document.querySelector("#SofaBedFrameInf").style.display = "none"; //.css('display','none');
      document.querySelector("#SofaBedMattressTitle").style.display = "none"; //.css('display','none');
      document.querySelector("#SofaBedMattressInf").style.display = "none"; //.css('display','none');
    }
  } else {
    document.querySelector("#SofaBedFrameTitle").style.display = "none"; //('display','none');
    document.querySelector("#SofaBedFrameInf").style.display = "none"; //.css('display','none');
    document.querySelector("#SofaBedMattressTitle").style.display = "none"; //.css('display','none');
    document.querySelector("#SofaBedMattressInf").style.display = "none"; //.css('display','none');
  }
}

document.addEventListener("variant:changed", function (event) {
  variant = event.detail.variant; // Gives you access to the whole variant details
  //variant, //product //metaFields // variantMeta
  var isCornerSofa = variant.option1.replace(/ /g, "_").toLowerCase();
  //console.log('variant',isCornerSofa);
  if(isCornerSofa.includes('left_hand') || isCornerSofa.includes('right_hand')){
    console.log(variant.id);
    var currentURL = new URL(window.location.href);
    currentURL.searchParams.set('variant', variant.id);
    window.location.href = currentURL.href;
//return;
  }
  //CREATE NEW DYNAMIC TITLE ON CHANGE
  var prodTitle = product.title;
  prodTitle = prodTitle.toLowerCase();

  var upholstery = "";
  var prodType = "";
  var color = "";
  var size = "";
  var sofabed = "";
  var pFound = true;
  try {
    if (variant.id === null) {
      console.log("unavailable");
    }
  } catch (e) {
    pFound = false;
    alert(
      "Sorry, this product is not available in the currently selected configuration"
    );
  }
  if (pFound) {
    sofaBedInf();
  }

  tagManager_productID = "shopify_GB_" + product.id + "_" + variant.id;
  //console.log(tagManager_productID);
  var priceTemp = variant.price;
  priceTemp = (priceTemp / 100).toFixed(2);
  tagManager_productPrice = priceTemp;
  //ga('set','dimension1',tagManager_productID);
  //ga('set','dimension3',tagManager_productPrice);

  if (prodTitle.indexOf("vintage") != -1) {
    upholstery = "Vintage Leather";
  } else if (prodTitle.indexOf("rustic") != -1) {
    upholstery = "Rustic Leather";
  } else if (prodTitle.indexOf("heritage") != -1) {
    upholstery = "Heritage Leather";
  } else if (prodTitle.indexOf("antique") != -1) {
    upholstery = "Antique Leather";
  } else if (prodTitle.indexOf("herringbone") != -1) {
    upholstery = "Herringbone Wool";
  } else if (prodTitle.indexOf("plush") != -1) {
    upholstery = "Plush Velvet";
  }

  if (prodTitle.indexOf("chesterfield") != -1) {
    prodType = "Chesterfield";
  } else if (prodTitle.indexOf("sofa") != -1) {
    prodType = "Sofa";
  } else if (prodTitle.indexOf("chair") != -1) {
    prodType = "Chair";
  } else if (prodTitle.indexOf("footstool") != -1) {
    prodType = "Footstool";
  }

  prodTitle = prodTitle.replace("vintage", "");
  prodTitle = prodTitle.replace("rustic", "");
  prodTitle = prodTitle.replace("heritage", "");
  prodTitle = prodTitle.replace("antique", "");
  prodTitle = prodTitle.replace("leather", "");
  prodTitle = prodTitle.replace("wool", "");
  prodTitle = prodTitle.replace("velvet", "");
  prodTitle = prodTitle.replace("herringbone", "");
  prodTitle = prodTitle.replace("plush", "");
  prodTitle = prodTitle.replace("chesterfield", "");
  prodTitle = prodTitle.replace("sofa", "");
  prodTitle = prodTitle.replace("chest", "chesterfield");

  var tempOpt1 = product.options[0];
  var tempOpt2 = product.options[1];
  var tempOpt3 = product.options[2];
  if (tempOpt1) {
    tempOpt1 = tempOpt1.toLowerCase();
  }
  if (tempOpt2) {
    tempOpt2 = tempOpt2.toLowerCase();
  }
  if (tempOpt3) {
    tempOpt3 = tempOpt3.toLowerCase();
  }

  if (tempOpt1 == "size") {
    size = variant.option1;
  } else if (tempOpt1 == "color") {
    color = variant.option1;
  }

  if (tempOpt2 == "size") {
    size = variant.option2;
  } else if (tempOpt2 == "color") {
    color = variant.option2;
  }

  if (tempOpt3 == "sofabed") {
    sofabed = variant.option3;
  }

  color = color.toLowerCase();
  var colorOrig = color;
  productColourChosen = color;
  size = size.toLowerCase();
  sofabed = sofabed.toLowerCase();

  color = color.replace("vintage", "");
  color = color.replace("rustic", "");
  color = color.replace("heritage", "");
  color = color.replace("antique", "");
  color = color.replace("herringbone", "");
  color = color.replace("velvet", "");

  //alert(variant.price, variant.compare_at_price);

  var outputTitle = "";
  if (
    color != "" &&
    size != "" &&
    (sofabed == "with sofabed" || sofabed == "with sofa bed")
  ) {
    outputTitle =
      capitalizeFirstLetter(prodTitle) +
      " " +
      size +
      " " +
      prodType +
      " in " +
      capitalizeFirstLetter(color) +
      " " +
      capitalizeFirstLetter(upholstery) +
      " - with sofa bed";
  } else if (color != "" && size != "") {
    outputTitle =
      capitalizeFirstLetter(prodTitle) +
      size +
      " " +
      prodType +
      " in " +
      capitalizeFirstLetter(color) +
      " " +
      capitalizeFirstLetter(upholstery);
  } else if (color != "") {
    outputTitle =
      capitalizeFirstLetter(prodTitle) +
      " in " +
      capitalizeFirstLetter(color) +
      " " +
      capitalizeFirstLetter(upholstery);
  }

  outputTitle = outputTitle.replace("chair Chesterfield", "Chesterfield Chair");

  var targetParent = document.querySelector(".ProductMeta");
  var targetChild = targetParent.querySelector(".ProductMeta__Title");
  targetChild.innerHTML = outputTitle;

  //CHANGE SIZES ON CHANGE
  if (size) {
    var sizeStr = size.replace(/ /g, "_").toLowerCase();
    if (sizeStr == "chair") {
      sizeStr = "1_seater";
    }
    var width = metaFields[sizeStr + "_width"];
    var height = metaFields[sizeStr + "_height"];
    var depth = metaFields[sizeStr + "_depth"];
    var seatSize = metaFields[sizeStr + "_seat_dimensions"];
    console.log(
      "//cdn.shopify.com/s/files/1/0270/3474/6980/files/",
      metaFields.product_code,
      "_",
      sizeStr,
      "_dimensions_800x.jpg?_V=",
      imageCacheBust
    );
    var sizeImage =
      "//cdn.shopify.com/s/files/1/0270/3474/6980/files/" +
      metaFields.product_code +
      "_" +
      sizeStr +
      "_dimensions_800x.jpg?_V=" +
      imageCacheBust;

    console.log("sizeImage:", sizeImage);

    document.querySelector(".ProductMeta .swj_prodwidth").innerHTML = width;
    document.querySelector(".swj_prodwidth2").innerHTML = width;
    document.querySelector(".swj_prodheight").innerHTML = height;
    document.querySelector(".swj_prodheight2").innerHTML = height;
    document.querySelector(".swj_proddepth").innerHTML = depth;
    document.querySelector(".swj_proddepth2").innerHTML = depth;
    if (
      sizeStr == "4_seater" ||
      sizeStr == "5_seater" ||
      sizeStr == "6_seater"
    ) {
      document.querySelector(".swj_prodseatsize").innerHTML =
        seatSize + "<br/>Available with 2 or 3 cushions on request";
    } else {
      document.querySelector(".swj_prodseatsize").innerHTML = seatSize;
    }
    if (document.querySelector(".swj_proddimensions")) {
      document.querySelector(".swj_proddimensions").src = sizeImage;
    }
  }

  var sofabedStr = "";
  if (sofabed == "with sofa bed") {
    sofabedStr = "with sofa bed";
  } else {
    sofabedStr = "";
  }

  //CHANGE DYNAMIC TAGS
  //$('.dynaimcColourTag').text(capitalizeFirstLetter(color));
  //$('.dynaimcSizeTag').text(capitalizeFirstLetter(size));
  //$('.dynaimcSofabedTag').text((sofabedStr));
  document.querySelectorAll(".dynaimcColourTag").forEach(function (thisEl) {
    thisEl.innerHTML = capitalizeFirstLetter(color);
  });
  document.querySelectorAll(".dynaimcSizeTag").forEach(function (thisEl) {
    thisEl.innerHTML = capitalizeFirstLetter(size);
  });
  document.querySelectorAll(".dynaimcSofabedTag").forEach(function (thisEl) {
    thisEl.innerHTML = capitalizeFirstLetter(sofabedStr);
  });

  //CHANGE ANGLE SHOTS
  if (metaFields["thumbs_change_on"] != "0") {
    document
      .querySelectorAll(".Product__SlideshowNavScroller a")
      .forEach(function (thisAnchor) {
        var href = ConvertImageThumb(
          thisAnchor.getAttribute("href"),
          colorOrig,
          size,
          thisAnchor
        );
        thisAnchor.setAttribute("href", href);
        var imageTarg = thisAnchor.querySelector("img");
        var src = ConvertImageThumb(
          imageTarg.getAttribute("src"),
          colorOrig,
          size,
          imageTarg
        );
        imageTarg.setAttribute("src", src);
        var dataSrc = ConvertImageThumb(
          imageTarg.getAttribute("data-src"),
          colorOrig,
          size,
          colorOrig
        );
        imageTarg.setAttribute("data-src", dataSrc);
        var dataOriginalSrc = ConvertImageThumb(
          imageTarg.getAttribute("data-original-src"),
          colorOrig,
          size,
          imageTarg
        );
        dataOriginalSrc = dataOriginalSrc.replace("_160x", "");
        imageTarg.setAttribute("data-original-src", dataOriginalSrc);
      });
  }

  //CHANGE SHIPPING INF
  var id = variant.id;
  var newShippingInf = metaFields["lead_time"];
  for (var i = 0; i < variantMeta.data.length; i++) {
    var thisVariantInf = variantMeta.data[i];
    if (thisVariantInf.id == id) {
      if (thisVariantInf.data.lead_time != "") {
        newShippingInf = thisVariantInf.data.lead_time;
      }
      break;
    }
  }
  if (newShippingInf) {
    document.querySelector("#DeliveryTime span,.DeliveryTime span").innerHTML =
      newShippingInf;
    //$('#DeliveryTime span,.DeliveryTime span').html(newShippingInf);
  }
  //Change Promo Roundel
  var newRoundelImg = metaFields["roundel_image"];
  var newRoundelTxt = metaFields["roundel_text"];
  var newRoundelUrl = metaFields["roundel_link"];
  for (var i = 0; i < variantMeta.data.length; i++) {
    var thisVariantInf = variantMeta.data[i];
    if (thisVariantInf.id == id) {
      if (thisVariantInf.data.roundel_image != "") {
        newRoundelImg = thisVariantInf.data.roundel_image;
      }
      if (thisVariantInf.data.roundel_text != "") {
        newRoundelTxt = thisVariantInf.data.roundel_text;
      }
      if (thisVariantInf.data.roundel_link != "") {
        newRoundelUrl = thisVariantInf.data.roundel_link;
      }
      break;
    }
  }
  var roundelTarget = document.querySelector("#roundelProduct img");
  var roundelTextRollBack = document.querySelector(
    "#roundelProduct .TextRollBack"
  );
  if (newRoundelImg) {
    roundelTarget.setAttribute("src", newRoundelImg);
    roundelTarget.style.visibility = "visible";
    //$('#roundelProduct img').attr("src",newRoundelImg).css('visibility','visible');
  } else {
    if (!AutoRoundel()) {
      try {
        roundelTarget.style.visibility = "hidden";
      } catch (e) {}
      //$('#roundelProduct img').css('visibility','hidden');
    }
  }
  if (newRoundelTxt) {
    roundelTextRollBack.querySelector("a").innerHTML = newRoundelTxt;
    //$('#roundelProduct .TextRollBack a').text(newRoundelTxt);
    roundelTextRollBack.style.visibility = "visible";
    //$('#roundelProduct .TextRollBack').css('visibility','visible');
  } else {
    //$('#roundelProduct .TextRollBack').css('visibility','hidden');
    try {
      roundelTextRollBack.style.visibility = "hidden";
    } catch (e) {}
  }
  if (newRoundelUrl) {
    //$('#roundelProduct a').attr("href",newRoundelUrl);
    document
      .querySelector("#roundelProduct a")
      .setAttribute("href", newRoundelUrl);
  }

  ProductFormManufactureMeta();
});

function ProductFormManufactureMeta() {
  var size = "";
  var color = "";
  var sofabed = "";
  var tempOpt1 = product.options[0];
  var tempOpt2 = product.options[1];
  var tempOpt3 = product.options[2];
  if (tempOpt1) {
    tempOpt1 = tempOpt1.toLowerCase();
  }
  if (tempOpt2) {
    tempOpt2 = tempOpt2.toLowerCase();
  }
  if (tempOpt3) {
    tempOpt3 = tempOpt3.toLowerCase();
  }

  if (tempOpt1 == "size") {
    size = variant.option1;
  } else if (tempOpt1 == "color") {
    color = variant.option1;
  }

  if (tempOpt2 == "size") {
    size = variant.option2;
  } else if (tempOpt2 == "color") {
    color = variant.option2;
  }

  if (tempOpt3 == "sofabed") {
    sofabed = variant.option3;
  }

  color = color.toLowerCase();
  var colorOrig = color;
  var productColourChosen = color;
  size = size.toLowerCase();
  sofabed = sofabed.toLowerCase();

  if (size) {
    var sizeStr = size.replace(/ /g, "_").toLowerCase();
    if (sizeStr == "chair") {
      sizeStr = "1_seater";
    }
    var width = metaFields[sizeStr + "_width"];
    var height = metaFields[sizeStr + "_height"];
    var depth = metaFields[sizeStr + "_depth"];
    if (width != "" && depth != "") {
      document.getElementById("metaPropertiesDimensions").value =
        width + "cm wide x " + depth + "cm deep x " + height + "cm high";
      //$('#metaPropertiesDimensions').val(width+'cm wide x '+depth+'cm deep x '+height+'cm high');
    }
  }

  var manuColour = "";
  if (color == "vintage dark brown") {
    manuColour = "Futura Cracked Wax Tobaco";
  } else if (color == "vintage honey") {
    manuColour = "Futura Cracked Wax Brown";
  } else if (color == "vintage black") {
    manuColour = "Futura Cracked Wax Black";
  } else if (color == "vintage green") {
    manuColour = "Futura Selvagio Verde";
  } else if (color == "vintage grey") {
    manuColour = "Futura Cracked Wax Grey";
  } else if (color == "heritage red wood") {
    manuColour = "Crest Old English Gamay";
  } else if (color == "heritage ebony") {
    manuColour = "Crest Old English Black";
  } else if (color == "heritage midnight blue") {
    manuColour = "Crest Old English Ocean";
  } else if (color == "rustic fox tail") {
    manuColour = "Futura Concrete Sudan Brown";
  } else if (color == "rustic tawny") {
    manuColour = "Futura Concrete Brown Tail";
  } else if (color == "rustic cocoa") {
    manuColour = "Futura Concrete Espresso";
  } else if (color == "rustic wine") {
    manuColour = "Futura Concrete Pinot";
  } else if (color == "rustic onyx") {
    manuColour = "Futura Concrete Black";
  } else if (color == "rustic slate") {
    manuColour = "Futura Concrete Charcoal";
  }
  if (manuColour) {
    document.getElementById("metaPropertiesManufactureColour").value =
      manuColour;
    //$('#metaPropertiesManufactureColour').val(manuColour);
  }
}

var trackAddToCartState = false;
function trackAddToCart() {
  if (!trackAddToCartState) {
    window.dataLayer.push({
      event: "addToCart",
    });
    trackAddToCartState = true;
  }
  setTimeout(function () {
    trackAddToCartState = false;
  }, 100);
}

var trackStartChckState = false;
var awCost = 0;
function trackStartCheck() {
  if (!trackStartChckState) {
    window.dataLayer.push({
      event: "checkoutStart",
      totalchkval: awCost,
    });
    trackStartChckState = true;
  }
  setTimeout(function () {
    trackStartChckState = false;
  }, 100);
}

function siteInit() {
  //var wishlistState = false;
  //if($('.SwatchRequest').length>0){
  // SwatchRequests();
  //  	var urlParams = new URLSearchParams(window.location.search);
  //	var myParam = urlParams.get('contact_posted');
  //  if(myParam){
  //    setTimeout(
  //      function(){
  //        $([document.documentElement, document.body]).animate({
  //                scrollTop: ($(".Alert--success").offset().top)-($('#section-header').height()+50)
  //            }, 500);
  //      }
  //      ,500);
  //  }
  //}

  if (document.querySelectorAll(".SwatchRequest").length > 0) {
    SwatchRequests();
  }

  if (document.querySelectorAll("button.ProductForm__Swatches").length > 0) {
    ShowHideSwatchArea();
  }
  if (document.querySelectorAll(".FinanceRequestArea .Button").length > 0) {
    ShowHideFinanceArea();
  }

  //HERO IMAGE CLICK OVERRIDE:
  const galleryClicks = document.querySelectorAll(
    ".Product__Slideshow.Product__Slideshow--zoomable,.Product__ActionItem"
  );
  for (const thisClick of galleryClicks) {
    thisClick.addEventListener("click", function (event) {
      var target = document.querySelector(".Product__SlideshowNavScroller a");
      target.querySelector("img").click();
      return false;
    });
  }

  //DEFAULT VARIANT OVERRIDE
  if (variantOverride) {
    for (var i = 0; i < product.variants.length; i++) {
      var thisVariant = product.variants[i];
      if (thisVariant.id == variantOverride) {
        if (thisVariant.option1 != "") {
          var targ = document.querySelector(
            'input[value="' + thisVariant.option1 + '"]'
          );
          var par = targ.parentNode;
          par.querySelector("label").click();
        }
        if (thisVariant.option2 != "") {
          var targ = document.querySelector(
            'input[value="' + thisVariant.option2 + '"]'
          );
          var par = targ.parentNode;
          par.querySelector("label").click();
        }
        if (thisVariant.option3 != "") {
          //$('input[value="'+thisVariant.option3+'"]').parent().find('label').click();
          var targ = document.querySelector(
            'input[value="' + thisVariant.option3 + '"]'
          );
          if (targ !== null) {
            var par = targ.parentNode;
            par.querySelector("label").click();
          }
        }
        break;
      }
    }
  }

  //SET DEFAULT UPHOLSTERY SWITCHER:
  var prodTitle = "";
  if (typeof product !== "undefined") {
    prodTitle = product.title;
    prodTitle = prodTitle.toLowerCase();
  }

  var upholstery = "";

  if (prodTitle.indexOf("vintage") != -1) {
    upholstery = "Vintage Leather";
  } else if (prodTitle.indexOf("rustic") != -1) {
    upholstery = "Rustic Leather";
  } else if (prodTitle.indexOf("heritage") != -1) {
    upholstery = "Heritage Leather";
  } else if (prodTitle.indexOf("antique") != -1) {
    upholstery = "Antique Leather";
  } else if (prodTitle.indexOf("herringbone") != -1) {
    upholstery = "Herringbone Wool";
  } else if (prodTitle.indexOf("plush") != -1) {
    upholstery = "Plush Velvet";
  }
  upholstery = upholstery.toLowerCase();

  if (upholstery.indexOf("vintage") != -1) {
    upholstery = "Vintage Leather";
  } else if (upholstery.indexOf("rustic") != -1) {
    upholstery = "Rustic Leather";
  } else if (upholstery.indexOf("heritage") != -1) {
    upholstery = "Heritage Leather";
  } else if (upholstery.indexOf("antique") != -1) {
    upholstery = "Antique Leather";
  } else if (upholstery.indexOf("herringbone") != -1) {
    upholstery = "Herringbone Wool";
  } else if (upholstery.indexOf("plush") != -1) {
    upholstery = "Plush Velvet";
  }

  var tsel = document.querySelector("#roundelProduct a");
  if (tsel) {
    tsel.setAttribute("href", newRoundelUrl);
  }
  var ttsel = document.querySelector(
    '#AlsoIn option[inf="' + upholstery + '"]'
  );
  if (ttsel) {
    ttsel.setAttribute("selected", true);
  }
  var tttsel = document.querySelector("#AlsoIn");
  if (tttsel) {
    tttsel.addEventListener("change", function (event) {
      location.assign(tttsel.value);
    });
  }

  //product tracking
  var tsel2 = document.querySelector(".ProductForm__AddToCart");
  if (tsel2) {
    tsel2.addEventListener("click", trackAddToCart, false);
    tsel2.addEventListener("touchstart", trackAddToCart, false);
    setTimeout(sofaBedInf, 200);
  }

  var ttsel2 = document.querySelector("#sidebar-cart");
  if (ttsel2) {
    awCost = ttsel2.getAttribute("awval");
  }

  //lazy load homepage video
  var homevideo = document.getElementById("homeVideoLoop");
  if (typeof homevideo != "undefined" && homevideo != null) {
    var videoSource = homevideo.getElementsByTagName("source");
    videoSource[0].src = videoSource[0].getAttribute("data-src");
    homevideo.load();
  }
  //load other videos
  if (document.querySelectorAll(".productVideo").length > 0) {
    setTimeout(function () {
      document.querySelectorAll(".productVideo").forEach(function (thisVideo) {
        var videoSource = thisVideo.getElementsByTagName("source");
        videoSource[0].src = videoSource[0].getAttribute("data-src");
        thisVideo.load();
      });
    }, 2000);
  }
  document.addEventListener("DOMContentLoaded", function () {
    if (lazyloadImages.length > 0) {
      document.addEventListener("wheel", swjlazyload, { passive: true });
      document.addEventListener("touchstart", swjlazyload, { passive: 1 });
    }
  });
}
var lazyloadImages = document.querySelectorAll(".lazyBG");
var lazyloadThrottleTimeout;

function swjlazyload() {
  if (lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }
  lazyloadImages = document.querySelectorAll(".lazyBG");
  lazyloadThrottleTimeout = setTimeout(function () {
    var scrollTop = window.pageYOffset;
    lazyloadImages.forEach(function (thisBG) {
      if (thisBG.getBoundingClientRect().top < window.innerHeight + scrollTop) {
        var src = thisBG.getAttribute("data-bgimage");
        thisBG.style.backgroundImage = src;
        thisBG.classList.remove("lazyBG");
        //console.log("load",thisBG,thisBG.getBoundingClientRect().top,scrollTop);
      }
    });
    if (lazyloadImages.length == 0) {
      document.removeEventListener("wheel", swjlazyload, { passive: 1 });
      document.removeEventListener("touchstart", swjlazyload, { passive: 1 });
    }
  }, 20);
}

function ConvertImageThumb(url, colour, size, element) {
  size = size.replace(" large", "");
  size = size.replace(" small", "");
  size = size.replace("snuggler", "1_seater");
  size = size.replace("chair", "1_seater");
  size = size.replace(" ", "_");

  if (size.trim().length !== 0 && size.match(/\d+/)) {
    const sizeNumber = parseInt(size.match(/\d+/)[0]);
    if (sizeNumber && element.getAttribute) {
      url = element.getAttribute(`data-image-size-${sizeNumber}`);
    } else if (element.getAttribute) {
      url = element.getAttribute(`data-image-size-1`);
    }
  }

  colour = colour.replace(/ /g, "_");
  const thumbsChangeOn = metaFields["thumbs_change_on"];

  if (thumbsChangeOn == "1" || thumbsChangeOn == "2") {
    url = url.replace(/_size_(\d?)_seater/g, "_size_" + size);
  }
  if (thumbsChangeOn == "1" || thumbsChangeOn == "3") {
    url = url.replace(
      /_colour_([a-zA-Z_\s]+)_thumb/g,
      "_colour_" + colour + "_thumb"
    );
  }

  return url;
}

function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  };
}

function showFinance() {
  //document.documentElement.scrollTop = 200;
  //document.body.scrollTop = 200;

  var targ = document.querySelector("#section-finance-request");
  var targ2 = document.querySelector(".klaviyo-form-TGxbDy");
  targ.style.display = "block";
  //var b = parseInt(window.getComputedStyle(document.querySelector("#section-header")).height);
  //var a = parseInt(getOffset(targ).top);
  //var dist = a - b;
  //console.log(a,b,dist);
  //document.documentElement.scrollY = 2000;
  //document.body.scrollY = 2000;
  //window.scroll(0,-400);
  targ2.scrollIntoView(false);
  return false;
}

function closeFinance() {
  var targ = document.querySelector("#section-finance-request");
  targ.style.display = "none";
}

function ShowHideFinanceArea() {
  var tsel = document.querySelector(".FinanceRequestArea .Button");
  if (tsel) {
    tsel.addEventListener("click", showFinance, false);
  }
  var tsel2 = document.querySelector("#closeFinance");
  if (tsel2) {
    tsel2.addEventListener("click", closeFinance, false);
  }
}

function showSwatches() {
  var targ = document.querySelector("#SwatchLoader");
  targ.style.display = "block";
  var b = parseInt(
    window.getComputedStyle(document.querySelector("#section-header")).height
  );
  var a = parseInt(getOffset(targ).top);
  var dist = a - b;
  document.documentElement.scrollTop = dist;
  document.body.scrollTop = dist;
}

function closeSwatches() {
  var targ = document.querySelector("#SwatchLoader");
  targ.style.display = "none";
}

function ShowHideSwatchArea() {
  var tsel = document.querySelector("button.ProductForm__Swatches");
  if (tsel) {
    tsel.addEventListener("click", showSwatches, false);
  }
  var tsel2 = document.querySelector("#closeSwatches");
  if (tsel2) {
    tsel2.addEventListener("click", closeSwatches, false);
  }
}

function swatchPickClear(e) {
  var targetElement = e.target || e.srcElement;
  var id = targetElement.getAttribute("for");
  var itemText = targetElement.getAttribute("data-tooltip");
  var pickerID = targetElement.getAttribute("data-pickerID");

  if (itemText != notSelected) {
    for (var i = 0; i < SwatchRequests.slots.length; i++) {
      if (SwatchRequests.slots[i] == itemText) {
        var targ = document.querySelectorAll(
          '.PickedSwatches[for="' + id + '"]'
        );
        //console.log('label.PickedSwatches[for="'+id+'"]',targ, id);
        for (var z = 0; z < 2; z++) {
          targ[z].setAttribute("style", "");
          targ[z].setAttribute("data-tooltip", notSelected);
        }
        SwatchRequests.slots[i] = "";
        document.getElementById(pickerID).checked = false;
        document
          .getElementById(pickerID)
          .parentElement.classList.remove("isSelected");
        //$('#'+pickerID).prop( "checked", false );
        //$('#'+pickerID).parent().removeClass("isSelected");
      }
    }
  }

  //console.log("nw",itemText,pickerID,targetElement,parentEl);
}

function swatchPickClick(e) {
  e.stopPropagation();
  e.preventDefault();
  var targetElement = e.target || e.srcElement;
  var id = targetElement.getAttribute("for");
  var parentEl = targetElement.parentElement;

  var available = false;
  for (var i = 0; i < SwatchRequests.slots.length; i++) {
    if (SwatchRequests.slots[i] == "") {
      available = true;
      break;
    }
  }

  if (parentEl.classList.contains("isSelected")) {
    for (var i = 0; i < SwatchRequests.slots.length; i++) {
      var val = document.getElementById(id).value;
      if (SwatchRequests.slots[i] == val) {
        SwatchRequests.slots[i] = "";
        var targ = document.querySelectorAll(
          'label[for="swatchReq_Pick' + (i + 1) + '"]'
        );
        for (var z = 0; z < 2; z++) {
          targ[z].setAttribute("style", "");
          targ[z].setAttribute("data-tooltip", notSelected);
        }
      }
    }
    parentEl.classList.toggle("isSelected");
  } else {
    if (available) {
      for (var i = 0; i < SwatchRequests.slots.length; i++) {
        if (SwatchRequests.slots[i] == "") {
          SwatchRequests.slots[i] = document.getElementById(id).value;
          var targ = document.querySelectorAll(
            'label[for="swatchReq_Pick' + (i + 1) + '"]'
          );
          var styleSet = document
            .querySelector('label[for="' + id + '"]')
            .getAttribute("style");
          for (var z = 0; z < 2; z++) {
            targ[z].setAttribute("style", styleSet);
            targ[z].setAttribute("data-tooltip", SwatchRequests.slots[i]);
            targ[z].setAttribute("data-pickerID", id);
          }
          break;
        }
      }
      parentEl.classList.toggle("isSelected");
    } else {
      alert(
        "Sorry, you can only order 5 swatches at a time. Please click a selected option to free up a slot."
      );
    }
  }

  var picked = document.getElementById("swatchesPicked");
  picked.value = "";

  for (var i = 0; i < SwatchRequests.slots.length; i++) {
    if (SwatchRequests.slots[i] != "") {
      if (i > 0) {
        picked.value = picked.value + ", " + SwatchRequests.slots[i];
      } else {
        picked.value = SwatchRequests.slots[i];
      }
    }
  }
  return false;
}

var swatchTiggered = false;
var notSelected = "No swatch selected";

function swatchSubmit(e) {
  var targetElement = e.target || e.srcElement;
  //console.log(targetElement);
  e.stopPropagation();
  e.preventDefault();
  //alert("Swatch requests are currently disabled for maintanance until 9PM. Sorry for the inconvenience");
  if (!swatchTiggered) {
    swatchTriggered = true;
    //console.log(document.querySelector('#swatchesPicked').value);
    if (document.querySelector("#swatchesPicked").value != "") {
      if (document.querySelector("#SwatchEmailInput").value != "") {
        document.querySelector(
          "#SwatchButtonMain .BouncingSpinner"
        ).style.display = "inline";
        if (
          document.querySelector("#shopify-section-header-intro-swatches") ==
          null
        ) {
          var temp = "";
          try {
            temp = variant.sku;
          } catch (e) {
            temp = tagManager_productID;
          }
          gtag("event", "SwatchRequest_ProductPage", {
            send_to: "UA-113460261-1",
            event_category: "Swatches",
            event_label: temp,
          });
        } else {
          gtag("event", "SwatchRequest_SwatchPage", {
            send_to: "UA-113460261-1",
            event_category: "Swatches",
            event_label: "Complete",
          });
        }

        formString = new FormData(
          document.querySelector(".Meta_Swatch #contact_form")
        );

        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function () {
          if (xmlHttp.readyState == 4) {
            var resp = xmlHttp.responseText;
            var complete = document.getElementById("SwatchCompleteMessage");
            complete.style.display = "block";
            document.getElementById("SwatchFormWrap").style.display = "none";
            document.querySelector(
              "#SwatchButtonMain .BouncingSpinner"
            ).style.display = "inline";
            complete.scrollIntoView(false);
          }
        };
        xmlHttp.open("post", "https://swatches.swjames.com/swatchReq.php");
        xmlHttp.send(formString);
      } else {
        alert("Missing Email Address");
      }
    } else {
      alert("No Swatches Selected. Please add upto 5 swatches to order.");
      swatchTriggered = false;
    }
  } else {
    alert(
      "Looks like something went wrong, please reload the page and retry, if the issue persists please email support"
    );
  }
}

function SwatchRequests() {
  var headerHeight = "";
  setTimeout(function () {
    headerHeight = document.querySelector(".NewHeaderWrap").offsetHeight;
    document.querySelector(".SwatchAnchorHolder2").style.top =
      headerHeight + "px";
  }, 500);
  //$('.SwatchAnchorHolder2').css('top',headerHeight+'px');

  SwatchRequests.slots = ["", "", "", "", ""];

  //$('.SwatchRequest.Picker .ColorSwatch__Radio').prop( "checked", false );
  document
    .querySelectorAll(".SwatchRequest.Picker .ColorSwatch__Radio")
    .forEach(function (thisRadio) {
      thisRadio.checked = false;
    });

  document
    .querySelectorAll("ul.SwatchRequest.PickedSwatches label")
    .forEach(function (thisLabel) {
      thisLabel.setAttribute("data-tooltip", notSelected);
    });

  document
    .querySelectorAll(".SwatchRequest.Picker li")
    .forEach(function (thisPicker) {
      thisPicker.addEventListener("click", swatchPickClick, false);
    });
  /*
 	$('.SwatchRequest.Picker li').click(
   	function(){
    	var id = $('.ColorSwatch__Radio',this).attr("id");
      	//CHECK FREE SLOTS:
      	var available = false;
      	for(var i=0;i<SwatchRequests.slots.length;i++){
        	 if(SwatchRequests.slots[i]==""){
              	available = true;
               	break;
             }
        }

     	if($(this).hasClass("isSelected")){
        	for(var i=0;i<SwatchRequests.slots.length;i++){
	       		if(SwatchRequests.slots[i]==$("#"+id).val()){
            		SwatchRequests.slots[i] = "";
                	$('label[for="swatchReq_Pick'+(i+1)+'"]').attr('style','');
              		$('label[for="swatchReq_Pick'+(i+1)+'"]').attr('data-tooltip',notSelected);
            	}
        	}
       		$(this).removeClass("isSelected");
     	}
     	else{
          	if(available){
              for(var i=0;i<SwatchRequests.slots.length;i++){
                  if(SwatchRequests.slots[i]==""){
                      SwatchRequests.slots[i] = $("#"+id).val();
                      $('label[for="swatchReq_Pick'+(i+1)+'"]').attr('style',$("label[for='"+id+"']").attr("style"));
                      $('label[for="swatchReq_Pick'+(i+1)+'"]').attr('data-tooltip',SwatchRequests.slots[i]);
                      $('label[for="swatchReq_Pick'+(i+1)+'"]').attr('data-pickerID',id);
                  break;
                  }
              }
              $(this).addClass("isSelected");
            }
          else{
           alert("Sorry, you can only order 5 swatches at a time. Please click a selected option to free up a slot.");
          }
     	}
     	$('#swatchesPicked').val("");
     	for(var i=0;i<SwatchRequests.slots.length;i++){
       		if(SwatchRequests.slots[i]!=""){
         		if(i>0){
         			$('#swatchesPicked').val($('#swatchesPicked').val()+", "+SwatchRequests.slots[i]);
         		}
         		else{
           			$('#swatchesPicked').val(SwatchRequests.slots[i]);
         		}
       		}
     	}
     	return false;
   	});
  */

  document
    .querySelectorAll(".SwatchRequest.PickedSwatches li")
    .forEach(function (thisPicker) {
      thisPicker.addEventListener("click", swatchPickClear, false);
    });

  /*
  	$('.SwatchRequest.PickedSwatches li').click(
      function(){
        var itemText = $('label',this).attr("data-tooltip");
        var pickerID = $('label',this).attr("data-pickerID");
        console.log("jq",itemText,pickerID);
        if(itemText != notSelected){
         	for(var i=0;i<SwatchRequests.slots.length;i++){
       			if(SwatchRequests.slots[i]==itemText){
             		SwatchRequests.slots[i] = "";
                  	$('label',this).attr('style','');
              		$('label',this).attr('data-tooltip',notSelected);
                  	$('#'+pickerID).prop( "checked", false );
                  	$('#'+pickerID).parent().removeClass("isSelected");
                }
            }
        }
      }
    );
    */
  PostCodeLookup();
  //var swatchForm = document.querySelector('.Meta_Swatch #contact_form');
  var swatchForm = document.querySelector("#SwatchButtonMain");

  swatchForm.addEventListener("click", swatchSubmit);

  /*
   $('.Meta_Swatch #contact_form').on("submit",function(e){
     	//console.log("here");
     	e.preventDefault();
     	if(!swatchTiggered){
          swatchTriggered = true;
          if($('#swatchesPicked').val() != ""){
            swatchForm = $(this);
            if($('#shopify-section-header-intro-swatches').length<=0){
                //console.log("too ");
                //console.log(variant.sku);
                var temp = '';
                try{
                 temp = variant.sku
                }
                catch(e){
                 temp = tagManager_productID;
                }
                gtag('event', 'SwatchRequest_ProductPage',{
                  'send_to': 'UA-113460261-1',
                  'event_category': 'Swatches',
                  'event_label': temp
                });
            }
            else{
                gtag('event', 'SwatchRequest_SwatchPage',{
                  'send_to': 'UA-113460261-1',
                  'event_category': 'Swatches',
                  'event_label': 'Complete'
                });
            }
            var data = $(this).serialize();

            $.ajax({
                type: 'POST',
                url: 'https://swatches.swjames.com/swatchReq.php',
                crossDomain: true,
                dataType: 'json',
                data : data,
                success:function(){
                    $('#SwatchCompleteMessage').css('display','block');
                  	$('#SwatchFormWrap').css('display','none');
                    $([document.documentElement, document.body]).animate({
                      scrollTop: ($("#SwatchCompleteMessage").offset().top)-($('#section-header').height()+150)
                  }, 100);
                }
              ,error:	function(e){
                alert("An error occured. Please check your data and retry");
                swatchTriggered = false;
              }
            });
            //$(this).submit();
          }
       else{
         alert("No Swatches Selected. Please add upto 5 swatches to order.");
         swatchTriggered = false;
       }
     }
  });
  */
}

////POSTCODE LOOKUP
/*
function Capture_Interactive_Find_v1_00Begin(Key, Text, Container, Origin, Countries, Limit, Language) {
    var script = document.createElement("script"),
        head = document.getElementsByTagName("head")[0],
        url = "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.00/json3.ws?";

    // Build the query string
    url += "&Key=" + encodeURIComponent(Key);
    url += "&Text=" + encodeURIComponent(Text);
    url += "&Container=" + encodeURIComponent(Container);
    url += "&Origin=" + encodeURIComponent(Origin);
    url += "&Countries=" + encodeURIComponent(Countries);
    url += "&Limit=" + encodeURIComponent(Limit);
    url += "&Language=" + encodeURIComponent(Language);
    url += "&callback=Capture_Interactive_Find_v1_00End";

    script.src = url;

    // Make the request
    script.onload = script.onreadystatechange = function () {
        if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
            script.onload = script.onreadystatechange = null;
            if (head && script.parentNode)
                head.removeChild(script);
        }
    }

    head.insertBefore(script, head.firstChild);
}
*/
function Capture_Interactive_Find_v1_00Begin(
  Key,
  Text,
  Container,
  Origin,
  Countries,
  Limit,
  Language
) {
  var script = document.createElement("script"),
    head = document.getElementsByTagName("head")[0],
    url =
      "https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.00/json3.ws?";

  // Build the query string
  url += "&Key=" + encodeURIComponent(Key);
  url += "&Text=" + encodeURIComponent(Text);
  url += "&Container=" + encodeURIComponent(Container);
  url += "&Origin=" + encodeURIComponent(Origin);
  url += "&Countries=" + encodeURIComponent(Countries);
  url += "&Limit=" + encodeURIComponent(Limit);
  url += "&Language=" + encodeURIComponent(Language);
  url += "&callback=Capture_Interactive_Find_v1_00End";

  script.src = url;

  // Make the request
  script.onload = script.onreadystatechange = function () {
    if (
      !this.readyState ||
      this.readyState === "loaded" ||
      this.readyState === "complete"
    ) {
      script.onload = script.onreadystatechange = null;
      if (head && script.parentNode) head.removeChild(script);
    }
  };

  head.insertBefore(script, head.firstChild);
}

/*
function Capture_Interactive_Find_v1_00End(response) {
    // Test for an error
    if (response.Items.length == 1 && typeof(response.Items[0].Error) != "undefined") {
        // Show the error message
        alert(response.Items[0].Description);
    }
    else {
        // Check if there were any items found
        if (response.Items.length == 0)
            alert("Sorry, there were no results");
        else {
			if(response.Items[0].Type=="Postcode"){
				var postcode = $('#'+PostCodeLookup.targetField).val();
				var Key = 'PA55-RZ55-KZ99-KA42';
				var PreferredLanguage = 'en';
				var Filter = '';
				var Country = "GBR";
				var MaxSuggestions = '';
				var MaxResults = 250;
				var SearchFor = "Everything";
				var SearchTerm = postcode;
				Capture_Interactive_Find_v1_00Begin(Key,SearchTerm,response.Items[0].Id,Country,Country,MaxResults,PreferredLanguage);
			}
			else{
				$('#'+PostCodeLookup.targetResults+' .Scrollable').html('');
				$('#'+PostCodeLookup.targetResults).removeClass('Hide').addClass('Show');
              	$('#AddressPartialForm').removeClass('Show');
				for(var i=0;i<response.Items.length;i++){
					$('#'+PostCodeLookup.targetResults+' .Scrollable').append('<div class="Row" rel="'+response.Items[i].Id+'"><p class="FullAddress">'+response.Items[i].Text+', '+response.Items[i].Description+'</p></div>');
				}
			}
		}
	}
}
*/
function Capture_Interactive_Find_v1_00End(response) {
  // Test for an error
  if (
    response.Items.length == 1 &&
    typeof response.Items[0].Error != "undefined"
  ) {
    // Show the error message
    alert(response.Items[0].Description);
  } else {
    // Check if there were any items found
    if (response.Items.length == 0) alert("Sorry, there were no results");
    else {
      if (response.Items[0].Type == "Postcode") {
        var postcode = document.getElementById(pcTargetField).value;
        var Key = "PA55-RZ55-KZ99-KA42";
        var PreferredLanguage = "en";
        var Filter = "";
        var Country = "GBR";
        var MaxSuggestions = "";
        var MaxResults = 250;
        var SearchFor = "Everything";
        var SearchTerm = postcode;
        Capture_Interactive_Find_v1_00Begin(
          Key,
          SearchTerm,
          response.Items[0].Id,
          Country,
          Country,
          MaxResults,
          PreferredLanguage
        );
      } else {
        var tr = document.querySelector("#" + pcTargetResults);
        tr.querySelector(".Scrollable").innerHTML = "";
        tr.classList.remove("Hide");
        tr.classList.add("Show");

        document.getElementById("AddressPartialForm").classList.remove("Show");
        for (var i = 0; i < response.Items.length; i++) {
          var rowContent =
            '<div class="Row" rel="' +
            response.Items[i].Id +
            '"><p class="FullAddress">' +
            response.Items[i].Text +
            ", " +
            response.Items[i].Description +
            "</p></div>";
          tr.querySelector(".Scrollable").innerHTML =
            tr.querySelector(".Scrollable").innerHTML + rowContent;
        }
        tr.querySelectorAll(".Row").forEach(function (thisRow) {
          thisRow.addEventListener("click", fetchAddressLookup);
        });
      }
    }
  }
}

function Capture_Interactive_Retrieve_v1_10Begin(Key, Id) {
  //console.log("clicked");
  var script = document.createElement("script"),
    head = document.getElementsByTagName("head")[0],
    url =
      "https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.10/json3.ws?";

  // Build the query string
  url += "&Key=" + encodeURIComponent(Key);
  url += "&Id=" + encodeURIComponent(Id);
  url += "&callback=Capture_Interactive_Retrieve_v1_10End";

  script.src = url;

  // Make the request
  script.onload = script.onreadystatechange = function () {
    if (
      !this.readyState ||
      this.readyState === "loaded" ||
      this.readyState === "complete"
    ) {
      script.onload = script.onreadystatechange = null;
      if (head && script.parentNode) head.removeChild(script);
    }
  };

  head.insertBefore(script, head.firstChild);
}

function Capture_Interactive_Retrieve_v1_10End(response) {
  // Test for an error
  if (
    response.Items.length == 1 &&
    typeof response.Items[0].Error != "undefined"
  ) {
    // Show the error message
    alert(response.Items[0].Description);
  } else {
    // Check if there were any items found
    if (response.Items.length == 0) alert("Sorry, there were no results");
    else {
      var ta = document.getElementById(pcTargetArea);
      var tr = document.getElementById(pcTargetResults);
      ta.classList.remove("Hide");
      ta.classList.add("Show");
      tr.classList.remove("Hide");
      tr.classList.add("Show");

      ta.querySelector('input[name="contact[address1]"]').value =
        response.Items[0].Line1;
      ta.querySelector('input[name="contact[address2]"]').value =
        response.Items[0].Line2;
      ta.querySelector('input[name="contact[postcode]"]').value =
        response.Items[0].PostalCode;
      ta.querySelector('input[name="contact[town]"]').value =
        response.Items[0].City;
      ta.querySelector('input[name="contact[county]"]').value =
        response.Items[0].Province;

      tr.classList.remove("Show");
      tr.classList.add("Hide");
      document.getElementById("AddressPartialForm").classList.add("Show");
    }
  }
}

function addressPCFormShow() {
  document.getElementById("AddressPartialForm").classList.add("Show");
}

function doPCLookup() {
  var DoPostcodeLookup = document.querySelector(".PostcodeLookup");

  pcTargetField = DoPostcodeLookup.getAttribute("targetFieldID");
  pcTargetResults = DoPostcodeLookup.getAttribute("targetResultsID");
  pcTargetArea = DoPostcodeLookup.getAttribute("targetAreaID");
  //console.log(pcTargetField,pcTargetResults,pcTargetArea);
  document.getElementById(pcTargetField).classList.remove("Error");
  var postcode = document.getElementById(pcTargetField).value;
  var Key = "PA55-RZ55-KZ99-KA42";
  var PreferredLanguage = "en";
  var Filter = "";
  var Country = "GBR";
  var MaxSuggestions = "";
  var MaxResults = 250;
  var SearchFor = "Everything";
  var SearchTerm = postcode;
  Capture_Interactive_Find_v1_00Begin(
    Key,
    SearchTerm,
    "",
    Country,
    Country,
    MaxResults,
    PreferredLanguage
  );
  return false;
}

var pcTargetField;
var pcTargetResult;
var pcTargetArea;
function PostCodeLookup() {
  //var EnterManualPostcodeButton = document.querySelector(".EnterManually");
  document
    .querySelector(".EnterManually")
    .addEventListener("click", addressPCFormShow);
  document
    .querySelector(".PostcodeLookup")
    .addEventListener("click", doPCLookup);

  /*
	$('.PostcodeLookup').click(
		function(){
			PostCodeLookup.targetField = $(this).attr('targetFieldID');
			PostCodeLookup.targetResults = $(this).attr('targetResultsID');
			PostCodeLookup.targetArea = $(this).attr('targetAreaID');
			//var validationResult = Validation(PostCodeLookup.targetField,'PostCode',2,8);
          	var validationResult=true;
			if(validationResult){
				$('#'+PostCodeLookup.targetField).removeClass('Error');
				var postcode = $('#'+PostCodeLookup.targetField).val();
				var Key = 'PA55-RZ55-KZ99-KA42';
				var PreferredLanguage = 'en';
				var Filter = '';
				var Country = "GBR";
				var MaxSuggestions = '';
				var MaxResults = 250;
				var SearchFor = "Everything";
				var SearchTerm = postcode;

				Capture_Interactive_Find_v1_00Begin(Key,SearchTerm,"",Country,Country,MaxResults,PreferredLanguage);
				return false;
			}
			else{
				$('#'+PostCodeLookup.targetField).addClass('Error');
				return false;
			}
		}
	);
    */
  /*
  	$(document).on('click','#AddressList .Row',function(){
		var Rel = $(this).attr('rel');
		var Key = 'PA55-RZ55-KZ99-KA42';
		Capture_Interactive_Retrieve_v1_10Begin(Key,Rel);
	});
    */
}

function fetchAddressLookup(e) {
  var targetElement = e.target || e.srcElement;
  var parentEl = targetElement.parentElement;
  var Rel = parentEl.getAttribute("rel");
  var Key = "PA55-RZ55-KZ99-KA42";
  Capture_Interactive_Retrieve_v1_10Begin(Key, Rel);
}

siteInit();
